module.exports = __webpack_public_path__ + "static/media/cup.77a5c545.png";